export default "__VITE_ASSET__0c586b5c__"